<template lang="pug">
.fetch-error-transition
  Spinner(v-if="isFetching")
  .error-container(v-else-if="parsedException")
    h1.h1 {{ errorTitle }}
    .error-message(v-if="errorMessage")
      pre {{ errorMessage }}
    .stack-trace(v-if="stackTrace")
      h2 Stack trace
      pre {{ stackTrace }}
  .error-container(v-else-if="error")
    h1 Oops...
    p {{ errorMessage }}
    BriqButton.button.mt-S(@click="goHome") Go home
  template(v-else)
    slot
</template>

<script>
import Spinner from '@v/components/Spinner.vue'

export default {
  name: 'FetchErrorTransition',
  components: { Spinner },
  props: {
    error: [String, Object, Error, Array],
    parsedException: Object,
    isFetching: Boolean,
  },
  computed: {
    errorTitle() {
      const genericMessage = 'An error has occured'
      if (typeof this.error === 'string') return this.error
      if (this.error?.response?.status === 400) return '400: Bad request'
      if (this.error?.response?.status === 401)
        return '401: You are not authorized to view this information'
      if (this.error?.response?.status === 500) return '500: Internal server error'
      return genericMessage
    },
    origin() {
      return this.parsedException?.origin
    },
    data() {
      return this.parsedException?.data
    },
    errorMessage() {
      const { exception, file, line, message } = this.data || {}
      return this.origin === 'laravel'
        ? `${exception} at ${file}:${line}\n${message}`
        : 'Something went wrong'
    },
    stackTrace() {
      // todo: hide stack trace for regular users
      const dotnetTrace = this.origin === 'dotnet' && this.data?.message
      const laravelTrace =
        this.origin === 'laravel' &&
        this.data?.trace.map(t => `at ${t.function} in ${t.class}:line ${t.line}`).join('\n')
      return dotnetTrace || laravelTrace
    },
  },
  methods: {
    goHome() {
      window.location.href = '/'
    },
  },
}
</script>

<style lang="stylus">
// Can't scope this, because the conditionally rendered items' classes don't work. Will not generate the scoped classes. Could not find the cause.
// If you replace IsFetching with a hardwired value, everything works as expected. Don't know why.

.fetch-error-transition
  width 100%
  display flex
  justify-content center

  & > .loading
    align-self center

  .error-container
    display flex
    flex-direction column
    margin-top 30px
    max-width 1200px

    .button
      align-self center

    h1
      text-align center
      margin-bottom 14px

.stack-trace
  padding 24px
  background white
  border 1px solid #666
</style>
